import type { SessionItem } from "@memorang/types/src/session/new-session";

/* -----------------Container--------------- */
import StudySessionItemContainer from "../../containers/StudySessionItemContainer";

/* -----------------Child components--------------- */
import { Box } from "@memorang/ui";
import { useLocalSearchParams } from "expo-router";
import useSessionStore from "../../hooks/useSessionStore";

interface Props {
	items: SessionItem[];
	toggleShowReadMore?: () => void;
}

const SessionListDesktop = ({ items, toggleShowReadMore }: Props) => {
	const localSearchParams = useLocalSearchParams<{
		index: string;
		id: string;
	}>();

	const isSummativeTest = useSessionStore((state) => state.isSummativeTest);
	const index = localSearchParams.index
		? Number.parseInt(localSearchParams.index)
		: 0;
	const sessionId = localSearchParams?.id;
	const currentItem = index ? items[index - 1] : items[0];

	return (
		// Full width so the item's ScrollViews receive wheel/trackpad events from
		// anywhere across the page; content width is clamped inside ItemWrapper.
		<Box
			style={{
				width: "100%",
				height: "100%",
			}}
			paddingHorizontal={isSummativeTest ? 16 : 0}
		>
			<StudySessionItemContainer
				item={currentItem}
				toggleShowReadMore={toggleShowReadMore}
				sessionId={sessionId ? Number.parseInt(sessionId) : undefined}
			/>
		</Box>
	);
};
export default SessionListDesktop;
